import {
  Button,
  Icon,
  PhoneMockup,
  PhoneMockupBodyLayout,
  WidgetHeader,
  WidgetHeaderContent,
  WidgetStatus,
} from '@frontend/ui-library';

import { links } from '../../constants';
import { useRegisterHotjarPage } from '../../hooks';

import { ReactComponent as LinkSvg } from '@frontend/icons/external-link-2.svg';

export default function Error(): JSX.Element {
  useRegisterHotjarPage('error');

  return (
    <PhoneMockup
      header={
        <WidgetHeader color="error">
          <WidgetHeaderContent title="Error" />
        </WidgetHeader>
      }
    >
      <PhoneMockupBodyLayout
        bodyCentered
        body={
          <WidgetStatus
            emoji="😕"
            title="Something went wrong..."
            description="Unfortunately we couldn’t process your request. You can
            refresh the page or try again later. If the problem persists
            our team is just one click away."
          />
        }
        footer={
          <Button
            as="a"
            size="large"
            href={links.support.HOME}
            target="_blank"
            rel="noopener noreferrer"
            variant="ghost"
            rightIcon={<Icon component={<LinkSvg />} />}
          >
            Contact Support
          </Button>
        }
      />
    </PhoneMockup>
  );
}
